import { API } from "@swivl-mono/api-helper";
import { DateHelper } from "@swivl-mono/helpers";
import { HourOfDay, SequenceInterface } from "@swivl-mono/types";
import { Button, ButtonColor, OptionsHelper, Select, SelectItem } from "@swivl-mono/ui";
import React from "react";

import { Member } from "../../../../Models/Member/Member.Current";
import { AlertsModel } from "../../../../Models/Notifications/Alerts.Model";

export function SequenceAdminTools(props: { sequence: SequenceInterface }) {
  const [hourOfDay, setHourOfDay] = React.useState(DateHelper.nowHourUTC());
  return (
    <div className="mt-5 rounded-md bg-white p-3">
      <label>ADMIN ONLY</label>
      Test Sequence
      <div className="flex flex-row">
        <Select
          options={OptionsHelper.hoursOptionsLocalized() as SelectItem[]}
          selectedValues={hourOfDay ? [hourOfDay] : []}
          hideClear
          onChange={(vals) => setHourOfDay(vals[0] as HourOfDay)}
        />
        <div className="ml-2">
          <Button
            color={ButtonColor.ORANGE}
            onClickAsync={async () => {
              const triggering = await API.Sequences.forceCheckSequence(Member.orgId, props.sequence.id, hourOfDay);
              if (triggering) {
                AlertsModel.successToast("Sequence Triggered");
              } else {
                AlertsModel.errorToast("Sequence Not Triggered");
              }
            }}
            className="w-full"
          >
            Trigger Sequence
          </Button>
        </div>
        <div className="ml-2 flex-1" />
      </div>
    </div>
  );
}
